var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._g(_vm._b({staticClass:"text-body-2",attrs:{"dismissible":_vm.dismissible,"icon":_vm.icon,"outlined":_vm.enfasis !== 'alto',"text":_vm.enfasis === 'medio',"type":_vm.type}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }